import { observer } from 'mobx-react-lite'
import { useOutletContext } from 'react-router'
import { type PayoutsAdminViewModel } from '@/features/payouts/admin/PayoutsAdminViewModel'
import { TransactionHistoryContainer } from '@/features/payouts/admin/transaction-history/components/TransactionHistory/TransactionHistoryContainer'

export default observer(function PayoutsAdminTransactionsContainer() {
  const vm = useOutletContext<PayoutsAdminViewModel>()
  return <TransactionHistoryContainer vm={vm.historyVm} />
})
